import MerchantSupport from '@components/ActivityPage/MerchantSupport'

export default {
  path: 'merchantSupportExample',
  component: MerchantSupport,
  stat: '商家扶持优秀案例'
}
